<template>
  <q-page
    padding
    class="bg-black"
  >
    <LocationClosedBanner />
    <MoyaAdvertRegion
      :region-id="1"
      class="max-width q-mb-xl"
    />

    <div
      v-if="offerCategories.length > 0"
      class="max-width q-py-xl"
    >
      <div class="row q-col-gutter-lg justify-center">
        <div
          v-for="offer in offerCategories"
          :key="offer.id"
          class="col-xs-12 col-md-6"
        >
          <div
            v-if="offer.products"
          >
            <OfferProductCard
              v-for="product in offer.products"
              :key="product.id"
              :product="product"
              :category-id="product.categoryId"
            />
          </div>
        </div>
      </div>
    </div>
    <MoyaAdvertRegion
      :region-id="2"
      class="max-width q-my-xl"
    />

    <div
      v-if="subCategories.length > 0"
      class="max-width q-py-lg"
      :style="backgroundStyle"
    >
      <div
        v-for="subCategory in subCategories"
        :key="subCategory.id"
      >
        <div
          class="text-center
          text-accent
          text-uppercase
          header-text
          q-mb-xl"
          style="overflow: hidden;"
        >
          <span class="text--heading__sideLines-accent">{{ subCategory.title }}</span>
        </div>
        <div
          class="row q-col-gutter-lg"
        >
          <FrontProductCard
            v-for="product in subCategory.products.slice(0, 12)"
            :key="product.id"
            :product="product"
            :category="subCategory"
            class="col-xs-12 col-sm-6 col-md-3 col-lg-3"
          />
        </div>
        <div class="text-center">
          <q-btn
            :label="$t('categoryTabs.view')"
            color="accent"
            rounded
            text-color="primary"
            class="q-btn--red text-center q-mt-xl text-weight-bold"
            icon-right="mdi-arrow-right"
            @click="$router.push({
              name: 'ViewCategory',
              params: {
                id: 2
              }
            })"
          />
        </div>
      </div>
    </div>
    <FrontpageImagesSection />
  </q-page>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import languageMixin from 'quasar-pilot-core/src/mixins/util/language';
import FrontProductCard from 'components/product/FrontCard';
import OfferProductCard from 'components/product/OfferCard';
import MoyaAdvertRegion from 'components/moya/AdvertRegion';
import LocationClosedBanner from 'components/layout/LocationClosedBanner';
import FrontpageImagesSection from 'components/frontpage/ImagesSection';

export default {
  components: {
    FrontpageImagesSection,
    MoyaAdvertRegion,
    OfferProductCard,
    FrontProductCard,
    LocationClosedBanner,
  },
  mixins: [languageMixin],

  data() {
    return {
      category: null,
      subCategories: [],
      frontCategoriesId: 10,
      offerCategoryId: 11,
      offerCategory: null,
      offerCategories: [],
    };
  },

  computed: {
    ...mapState('location', { currentLocation: 'current' }),
    ...mapGetters('category', ['findCategory']),
    baseUrl() {
      return process.env.NODE_ENV === 'production' ? '/panta' : '';
    },

    backgroundStyle() {
      return {
        backgroundImage: `url('${this.baseUrl}/meals-bg.png')`,
        backgroundPosition: 'bottom',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        overflowX: 'visible',
      };
    },
  },

  async mounted() {
    await this.updateProducts();
    await this.updateOfferProducts();
  },

  methods: {
    updateProducts() {
      this.category = this.findCategory(this.frontCategoriesId);

      if (this.category?.children) {
        this.category.children.forEach((child) => {
          const childCategory = this.findCategory(child.id);
          if (childCategory) {
            this.subCategories.push(childCategory);
          }
        });
      }
    },
    updateOfferProducts() {
      this.offerCategory = this.findCategory(this.offerCategoryId);
      if (this.offerCategory?.children) {
        this.offerCategory.children.forEach((subCategory) => {
          this.offerCategories.push(this.findCategory(subCategory.id));
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.q-page {
  overflow-x: hidden;
}

.promo {
  margin: -40px -24px 40px;
  padding: 40px 24px;
  height: 600px;

  @media (max-width: $breakpoint-sm-max) {
    margin: -40px -7px 40px;padding: 40px 7px;
    height: auto;
  }
}
.q-tabs {
  ::v-deep .q-tabs__content {
    @media (max-width: $breakpoint-xs-max) {
      display: flex;
      flex-direction: column;
    }
  }
  ::v-deep .q-tab__content {
    padding-bottom: 20px;
  }
}
.q-tab-panels {
  background: $brand-gray;
}
::v-deep .q-tab__indicator {
  color: $brand-red!important;
  width: 140px;
  margin: 0 auto;
}
.text {
  &-sub {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
  }
  &-main {
    font-style: normal;
    font-size: 32px;
  }
}
</style>
